import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../components/Button.css";
import { Row, Col, Button, Container, Table, Form } from "react-bootstrap";
import moment from "moment";
import "../formsList.css";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import SecurePageSection from "../../SecurePageSection";

const Aaina = () => {
  const user = useSelector((state) => state.authentication.user);

  const [grpName, setgrpName] = useState(""); // Selected group
  const [groups, setgroups] = useState([]); // Your groups data
  const [forms, setForms] = useState([]); // All forms
  const [groupForms, setgroupForms] = useState([]); // Forms filtered by group
  const [selectedGroup, setSelectedGroup] = useState("All");
  const [groupNames, setGroupNames] = useState([]);

  const fetchgroups = async () => {
    const response = await axios.get("/user/group");

    setgroups(response.data.sort((a, b) => a.group.localeCompare(b.group)));
  };

  useEffect(() => {
    fetchgroups();
  }, []);

  let filterUrl = "";

  if (grpName === "") {
    filterUrl = `/api/forms/aainas/`;
  }
  if (grpName !== "") {
    filterUrl = `/api/forms/group/filter/aaina/?grpName=${grpName}`;
  }

  const fetchForms = async () => {
    const response = await axios.get("/api/forms/aainas/");
    console.log(response);
    const formData = response.data;
    setForms(response.data);

    const startDate = new Date("2025-09-15");
    const endDate = new Date("2027-12-20");

    const filteredForms = formData.filter((form) => {
      const eDate = new Date(form.eDate);
      return eDate >= startDate && eDate <= endDate;
    });

    const sortedForms = filteredForms.sort((a, b) => {
      const dateA = new Date(a.eDate);
      const dateB = new Date(b.eDate);
      return dateB - dateA;
    });

    const uniqueGroups = [
      ...new Set(sortedForms.map((form) => form.grpName.toLowerCase())),
    ];
    setGroupNames(uniqueGroups);

    setForms(sortedForms);
    console.log(sortedForms);
  };

  const navigate = useNavigate();

  useEffect(() => {
    fetchForms();
  }, [grpName]);

  const handleStatusChange = async (e, formId) => {
    const newStatus = e.target.checked; // true if checked, false if unchecked
    const updatedForms = forms.map((form) =>
      form.id === formId ? { ...form, status: newStatus } : form
    );
    setForms(updatedForms);

    try {
      const response = await axios.put(`/api/forms/aaina/${formId}/`, {
        status: newStatus,
      });

      if (response.status === 200) {
        const updatedForms = forms.map((form) =>
          form.id === formId ? { ...form, status: newStatus } : form
        );
        setForms(updatedForms);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      const updatedForms = forms.map((form) =>
        form.id === formId ? { ...form, status: !newStatus } : form
      );
      setForms(updatedForms);
      // Handle error accordingly
    }
  };

  return (
    <div>
      {/* <SecurePageSection accessableUsers={"admin"} /> */}
      <Container className="body">
        <Row style={{ marginBottom: "1em" }}>
          <Col xs={10}>
            <h2>Aaina </h2>
          </Col>
        </Row>

        {(() => {
          if (
            (typeof user !== "undefined" && user.username === "JSGSRC002") ||
            (typeof user !== "undefined" && user.accessGroup === "admin") ||
            (typeof user !== "undefined" && user.accessGroup === "aaina")
          ) {
            return (
              <Row style={{ marginBottom: "10px" }}>
                <Col>
                  <Form.Label>Group</Form.Label>
                  <Form.Select
                    value={selectedGroup}
                    onChange={(e) => setSelectedGroup(e.target.value)}
                  >
                    <option value="All">All</option>
                    {groupNames.map((name) => (
                      <option
                        key={name}
                        style={{ textTransform: "capitalize" }}
                        value={name}
                      >
                        {name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
            );
          }
        })()}

        <Table striped bordered responsive="md" hover>
          <thead className="tableHead">
            <tr>
              <th>S. No.</th>
              <th>Submission Date</th>
              <th>Group</th>
              <th>Event Name</th>
              <th>Event Date</th>
              <th>View Report</th>
              {(() => {
                if (
                  (typeof user !== "undefined" &&
                    user.accessGroup === "admin") ||
                  (typeof user !== "undefined" && user.username === "admin")
                ) {
                  return <th>Status</th>;
                }
              })()}
            </tr>
          </thead>
          <tbody className="tableBody">
            {forms
              .filter((form) =>
                selectedGroup === "All"
                  ? true
                  : form.grpName.toLowerCase() === selectedGroup.toLowerCase()
              )
              .slice(0)
              .reverse()
              .map((form, index) => (
                <tr key={form.id}>
                  <td>{index + 1}</td>
                  <td>{moment(form.recdDate).format("DD-MM-YYYY")}</td>
                  <td>{form.grpName}</td>
                  <td>{form.eName}</td>
                  <td>{moment(form.eDate).format("Do MMMM YYYY")}</td>
                  <td style={{ width: "20rem" }}>
                    <Row>
                      <Col>
                        <div style={{ textAlign: "center" }}>
                          <LinkContainer to={`/aaina-response/${form.id}`}>
                            <Button variant="light" className="btn--four">
                              View Report
                            </Button>
                          </LinkContainer>
                        </div>
                      </Col>
                    </Row>
                  </td>
                  {((user && user.accessGroup === "admin") ||
                    (user && user.username === "admin")) && (
                    <td style={{ textAlign: "center" }}>
                      <Form.Check
                        type="checkbox"
                        checked={form.status}
                        onChange={(e) => handleStatusChange(e, form.id)}
                      />
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </Table>
      </Container>
    </div>
  );
};

export default Aaina;
